import { render, staticRenderFns } from "./MainLogo.vue?vue&type=template&id=4cbf04b1&"
import script from "./MainLogo.vue?vue&type=script&lang=ts&"
export * from "./MainLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports